import { BreadcrumbsService } from './../../../../services/cms/breadcrumbs.service';
import { Breadcrumbs } from './../../../../models/cms/breadcrumbs';
//Angular
import { Component, OnInit, ViewContainerRef, ComponentFactory, ReflectiveInjector, Compiler, Input, Inject, Renderer } from "@angular/core";
import { Router, ActivatedRoute } from '@angular/router';

//Services
import { ProductService } from "./../../../../services/inventory/product.service";
import { LanguageService } from "./../../../../services/cms/language.service";
import { ComponentHelperService } from "./../../../../services/core/component-helper.service";
import { TemplateService } from "./../../../../services/settings/template.service";
import { SeoService } from "./../../../../services/core/seo.service";
import { RoutesService } from "./../../../../services/core/routes.service";
import { ScriptService } from "./../../../../services/cms/script.service";
import { HelperService } from "./../../../../services/core/helper.service";

//Models
import { Product } from "./../../../../models/inventory/inventory";
import { SeoViewModel } from "./../../../../models/core/seo";

import { Subscription } from 'rxjs/Subscription';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
    template: ""
})

export class OtherProductComponent implements OnInit {
    product: Product = new Product();

    constructor
        (
            private _compiler: Compiler,
            private componentHelper: ComponentHelperService,
            private _elementRef: ViewContainerRef,
            private productService: ProductService,
            private languageService: LanguageService,
            private route: ActivatedRoute,
            private router: Router,
            @Inject('isBrowser') private isBrowser: boolean,
            private seo: SeoService,
            private renderer: Renderer,
            @Inject(DOCUMENT) private document: any,
            private scriptService: ScriptService
        ) { }

    subManager = new Subscription();

    ngOnInit() {
        //Reading Language information
        let lang: string = this.languageService.getLongLang();

        //Reading id from url
        //If id is set, then the information is retrived by id, else by url
        let paramsSub = this.route.params.subscribe(params => {
            let id = params['id'];

            if (id !== undefined) {
                let productId: number = id;

                let productByIdSub = this.productService.getProductDetails(productId, "altroProdotto", lang).subscribe(result => {
                    if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }

                    if (this.isBrowser) {
                        this.onGetProductSuccess(result);
                    }
                    else {
                        //-- Get head and body scripts
                        this.scriptService.setupExternalScripts(result, this.scriptService.typeCatalogOtherProduct, productId);

                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                        this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
                    }
                });

                this.subManager.add(productByIdSub);
            }
            else {
                let url = this.router.url;

                let productByUrlSub = this.productService.getProductDetailsBySeoUrl(lang, url).subscribe(result => {
                    if (result.SeoInformation) {
                        result.SeoInformation.ShortDescription = result.ShortDescription ? result.ShortDescription : '';
                        result.SeoInformation.LongDescription = result.LongDescription ? result.LongDescription : '';
                    }

                    if (this.isBrowser) {
                        this.onGetProductSuccess(result);
                    }
                    else {
                        //-- Get head and body scripts
                        this.scriptService.setupExternalScripts(result, this.scriptService.typeCatalogOtherProduct, result.Id);

                        //-- Setting SEO data for server side rendering, so it is visible for indexers and crawlers
                        this.seo.setSeoMetaData(this.document, this.renderer, result.SeoInformation)
                        this.seo.generateSeoDomServerSide(this.document, this.renderer, result.SeoInformation);
                    }
                });

                this.subManager.add(productByUrlSub);
            }
        });

        this.subManager.add(paramsSub);
    }

    ngOnDestroy() {
        this.subManager.unsubscribe();
    }

    onGetProductSuccess(productResult: Product) {
        if (productResult.Active != true) {
            //Creating sub-component with the returned information
            let subComponent = this.createSubComponentRedirect();

            //Injecting dynamically created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
        else {
            let subComponent = this.createSubComponent(productResult);

            //Injecting dynamically created component (OK)
            this.componentHelper.injectComponent(this._compiler, this._elementRef, subComponent);
        }
    }

    private createSubComponentRedirect() {
        @Component({
            template: ""
        })

        class ChildComponent implements OnInit {
            constructor
                (
                    private router: Router,
                    private routeService: RoutesService,
            ) { }

            ngOnInit(): void {
                let notFoundPage = this.routeService.getRoutePath('NOT - FOUND');
                this.router.navigate(notFoundPage);
            }
        }

        return ChildComponent;
    }


    private createSubComponent(otherproductObj: Product) {
        @Component({
            template: otherproductObj.TemplateHtml
        })

        class ChildComponent implements OnInit {
            product: Product = otherproductObj;

            private seoInfo: SeoViewModel = otherproductObj.SeoInformation;

            private loginPageName: string[] = [];
            private registerPageName: string[] = [];
            private pageIsInit: boolean = false;
            private breadcrumbs: Breadcrumbs[] = [];

            constructor
                (
                    private seoService: SeoService,
                    private routeService: RoutesService,
                    @Inject('isBrowser') private isBrowser: boolean,
                    private _elementRef: ViewContainerRef,
                    private scriptService: ScriptService,
                    private helperService: HelperService,
                    private breadcrumbsService: BreadcrumbsService
                ) { }

            ngOnInit() {
                //setting new breadcrumbs, setTimeout must be called because it is initializating new event, in opposite, app is crashed
                this.breadcrumbs = otherproductObj.BreadcrumbsInfo;
                setTimeout(x => this.breadcrumbsService.setBreadcrumbs(this.breadcrumbs), 1);

                this.loginPageName = this.routeService.getRoutePath('LOGIN');
                this.registerPageName = this.routeService.getRoutePath('REGISTRAZIONE');
            }

            imageTitle(imgPath) {
                let imgName = this.helperService.GetFileNameFromPath(imgPath);

                return imgName;
            }

            shareOnFacebook() {
                window.open('https://www.facebook.com/sharer/sharer.php?u=' + this.seoInfo.Url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            }

            shareOnTwitter() {
                window.open('https://twitter.com/intent/tweet?&url=' + this.seoInfo.Url, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
            }

            showedFileBox() {
                let result: boolean = true;

                if (this.product.ManageAttachment == "Combinazioni") {
                    result = false;
                }
                return result;
            }
            ngAfterViewChecked() {
                if (!this.isBrowser || this.pageIsInit) {
                    return;
                }

                //-- Set title, setup google analytics and other libraries 
                this.scriptService.setGoogleScripts(this.seoInfo);

                //hiding of loading panel after we get all data we need
                this.routeService.hidePageLoader();

                layoutTheme.initCarousel();
                layoutTheme.initLightbox();

                this.pageIsInit = true;
            }
        }

        return ChildComponent;
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/components/inventory/product/sys/other-product.component.ts